import datepicker from 'bootstrap-datepicker';

$('.datepicker').datepicker({
    format: 'dd/mm/yyyy',
    endDate: new Date().toLocaleString('nl-BE', {day: '2-digit', month: '2-digit', year: 'numeric'})//locale 'nl-BE' => dd/mm/yyyy
});

